export default {
  boolean: 'boolean',
  coordinate: 'coordinate',
  currency: 'currency',
  date: 'date',
  datetime: 'datetime',
  float: 'float',
  integer: 'integer',
  percentage: 'percentage',
  string: 'string',
  uuid: 'uuid',
  image: 'image',
  custom: 'custom',
  link: 'link',
  list: 'list',
};
